import React from 'react';
import { Loader2, Crown, Zap } from '../utils/icons';

const LoadingScreen: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center gradient-bg">
      <div className="text-center animate-fade-in-up">
        <div className="relative mb-8">
          <Crown className="h-16 w-16 text-white mx-auto mb-4" />
          <div className="absolute -top-2 -right-2 w-6 h-6">
            <Zap className="w-6 h-6 text-yellow-400 animate-bounce" />
          </div>
        </div>
        
        <h1 className="text-3xl font-bold text-white mb-4">
          Universal Crown Prime
        </h1>
        
        <p className="text-white/80 mb-8 max-w-md mx-auto">
          Initializing intelligent project detection and setup systems...
        </p>
        
        <div className="flex items-center justify-center space-x-2">
          <Loader2 className="h-6 w-6 text-white animate-spin" />
          <span className="text-white/90">Loading...</span>
        </div>
        
        <div className="mt-8 w-64 mx-auto">
          <div className="bg-white/20 rounded-full h-2 overflow-hidden">
            <div className="h-full bg-white rounded-full animate-progress" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
